module.exports = __webpack_public_path__ + "cf0f344cd94a244bdab7112279039c3a.jpg";